import React, { useEffect, useState } from "react";
import { Link, useHistory, useParams } from "react-router-dom";
import { toast } from "react-toastify";
import SelectInput from "src/_common/components/form-elements/selectinput/selectInput";
import { useEventApi } from "src/_common/hooks/actions/event/appEventApiHook";
import { useAppEventGameListSelector } from "src/_common/hooks/selectors/eventSelector";
import { useAppUserDetailsSelector } from "src/_common/hooks/selectors/userSelector";
import { CRYPTO_SECRET_KEY, removeTrailingZero, URLS } from "src/_config";
import Sponsor from "src/components/common/Sponsor";

const Cryptr = require("cryptr");
const cryptr = new Cryptr(CRYPTO_SECRET_KEY);

export default function RodeoGroupLeaderBoardPage() {
  const eventApi = useEventApi();
  const history = useHistory();
  const { groupId } = useParams<any>();
  const g_id: number = parseInt(cryptr.decrypt(groupId));
  const [leaderboardData, setLeaderboardData] = useState<any>([]);
  const [leaderboardType, setLeaderboardType] = useState<any>(0);
  const userDetails = useAppUserDetailsSelector();
  const [leaderboardList, setLeaderboardList] = useState<any>();
  const eventGameListSelector = useAppEventGameListSelector();
  const tiebreakerText = "RANDOM DRAW NUMBER (to be used for tie breaker): ";

  const goBack = (e: any) => {
    history.goBack();
  };

  const callViewGroupLeaderBoard = () => {
    const params = {
      group_id: g_id,
    };
    eventApi.callViewGroupLeaderBoard(
      params,
      (message: string, resp: any) => {
        if (resp) {
          setLeaderboardData(resp);
        }
      },
      (message: string) => {
        toast.error(message);
      }
    );
  };

  useEffect(() => {
    callViewGroupLeaderBoard();
  }, []);

  useEffect(() => {
    if (leaderboardData?.rodeo_event_game_info?.length > 0) {
      let x = leaderboardData?.rodeo_event_game_info[0].show_leaderboard;
      console.log(">>>>>>>leaderboard", x, leaderboardData);
      if (x) {
        setLeaderboardType(x);
        if (x == 1) {
          setLeaderboardList(leaderboardData?.players);
        } else if (x == 2) {
          setLeaderboardList(leaderboardData?.riders);
        } else {
          setLeaderboardList(leaderboardData?.events);
        }
      }
    }
  }, [leaderboardData]);

  return (
    <React.Fragment>
      <h2 className="page-title text-left">
        <Link to="#" onClick={(e) => goBack(e)} className="back-history">
          <img src="/images/left-white.svg" alt="back" />
        </Link>
        Leaderboard
      </h2>
      <div className="text-center text-white my-3">{leaderboardData?.group_details?.title}</div>
      {leaderboardData?.group_details?.sub_heading && (
        <div className="text-center text-white pb-3">
          {/* {leaderboardList?.length && leaderboardList[0]?.per_tie_total
          ? tiebreakerText + leaderboardList[0]?.per_tie_total
          : ""} */}
          {/* Overall Leaderboard shows how many tickets the top players have for the Rafter P Barn Givewaway */}
          {leaderboardData?.group_details?.sub_heading}
        </div>
      )}
      {/* <div className="text-center text-white pb-3">
        {performanceId
          ? tiebreakerText + leaderboardData?.performance_dtls?.tie_breaker_code || ""
          : (leaderboardList?.length && leaderboardList[0]?.per_tie_total
              ? tiebreakerText + leaderboardList[0]?.per_tie_total
              : "") || ""}
      </div> */}
      {/* {userDetails && leaderboardData?.rodeo_event_dtls?.is_assign_geo_location == "1" && (
        <SelectInput
          onChange={handleListChange}
          value={undefined}
          defaultValue={{ label: "Overall", value: "0" }}
          options={listOptions}
          // error={errors.country}
          placeholder="Select"
        />
      )} */}
      <div className="score-range-wrap">
        <div className="score-box d-flex justify-content-between">
          {/* <h4 className="d-inline-block title-player">{leaderboardType==3 ? "Events" : "Riders"}</h4> */}
          <h4 className="d-inline-block title-player">
            {leaderboardType == 3 ? "Events" : leaderboardType == 1 ? "Correct Picks" : "Riders"}
          </h4>
          {/* <div className="gua-sc">{"Tie Breaker Code"}</div> */}
          <div className="gua-sc">{leaderboardType == 2 ? "Vote Received(%)" : "Result"}</div>
        </div>
        <ul className="cons-list">
          {leaderboardList && leaderboardList?.length ? (
            leaderboardList?.map((item: any, i: any) => (
              <li key={i}>
                <span className="name-img leaderboard-name-img flex-fill">
                  {leaderboardType == 2
                    ? item?.name
                    : leaderboardType == 1
                    ? item?.user_details?.display_name || item?.user_details?.full_name
                    : leaderboardType == 3
                    ? item?.event_name || item?.details?.rodeo_pick_event?.title
                    : ""}
                </span>
                {/* <span className="count-vote p-0 flex-fill" style={{ textAlign: "center" }}>
                  {item?.user_tie_total == 99999 || item?.user_tie_total == 9999999 ? "-" : item?.user_tie_total || "-"}
                </span> */}
                <span className="count-vote flex-fill">
                  {
                    // userDetails &&
                    // eventGameListSelector?.filter((x: any) => x.ispicked).length > 0 &&
                    leaderboardType == 2 && item.vote
                      ? removeTrailingZero(item.vote)
                      : leaderboardType == 1 && Number(item?.total_win)
                      ? item?.total_win
                      : // ? item?.total_win + "/" + leaderboardData?.events_count
                      leaderboardType == 3 && Number(item?.total_win)
                      ? item?.total_win
                      : "-"
                  }
                  {/* {
                    leaderboardType==2 && item.vote ? removeTrailingZero(item.vote) : leaderboardType==1 && item?.total_win ? item?.total_win+"/"+leaderboardData?.events_count : leaderboardType==3 && item?.total_win ? item?.total_win : '-'
                } */}
                  {/* {
                    leaderboardType==1 && item?.total_win ? item?.total_win+"/"+leaderboardData?.events_count : (eventGameListSelector?.filter((x:any)=>x.ispicked).length>0 ? (leaderboardType==2 && item.vote ? removeTrailingZero(item.vote) : (leaderboardType==3 && item?.total_win ? item?.total_win : '-')) : '-')
                } */}
                </span>
              </li>
            ))
          ) : (
            <li className="no-rider">No record found!</li>
          )}
        </ul>
      </div>
      <Sponsor />
    </React.Fragment>
  );
}
